import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalDeleteItem from '../../Modal-Delete-Item';
import Area from './Area';
import { Kanban } from 'libs/kanban';
import { TabPaneStyles } from '../Tab-Pane-Focuses/styles';

const TabPaneAreas = ({ setStatus, areas, setAreas }) => {
  const { t: translate } = useTranslation();
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const deleteArea = async () => {
    return seo.deleteTypeItem('areas', selectedArea.id);
  };

  return (
    <TabPaneStyles>
      <span>{translate('Areas')}</span>
      <div className="d-flex flex-column gap-2">
        {(Array.isArray(areas) ? areas.filter(Boolean) : []).map((status) => (
          <Area
            key={status?.id}
            id={status?.id}
            name={status?.name}
            setItems={setAreas}
            index={areas.filter(Boolean).findIndex((col) => col.id === status.id)}
            total={areas.filter(Boolean).length}
            isNew={status.isNew}
            setSelectedItem={setSelectedArea}
            setIsOpenModalDelete={setIsOpenModalDelete}
            setStatus={setStatus}
          />
        ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() => {
            if (!Array.isArray(areas)) {
              setAreas([{ id: 'temp-1', name: '', isNew: true }]);
            } else {
              setAreas([
                ...areas.filter(Boolean),
                { id: `temp-${areas.filter(Boolean).length + 1}`, name: '', isNew: true },
              ]);
            }
          }}
        >
          <i className="bx bx-plus" />
          {translate('Add area')}
        </Button>
      </div>
      <ModalDeleteItem
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        item={selectedArea}
        setItems={setAreas}
        setStatus={setStatus}
        onDelete={deleteArea}
        headerText="Delete area"
        bodyText="Are you sure you want to delete the area {{item}}?"
      />
    </TabPaneStyles>
  );
};

TabPaneAreas.propTypes = {
  setStatus: PropTypes.func.isRequired,
  areas: PropTypes.array.isRequired,
  setAreas: PropTypes.func.isRequired,
};

export default TabPaneAreas;
